import {
  Mail,
  Phone,
  MapPin,
  Twitter,
  Facebook,
  Linkedin,
  Instagram,
  FileText
} from "lucide-react";
import logo from "../assets/AiWisedom-logo.avif";
import {useTranslation} from "react-i18next";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const quickLinks = [
    // { name: "Resume Analysis", href: "/analyze" },
    // { name: "ATS Checker", href: "/ats-checker" },
    // { name: "Templates", href: "/templates" },
    // { name: "Career Insights", href: "/insights" },
    // { name: "About Us", href: "/about" },
    // { name: "Careers", href: "/careers" },
    // { name: "Blog", href: "/blog" },
    // { name: "Press", href: "/press" },
    // { name: "Help Center", href: "/help" },
    { name: t("footer.quickLinks.contactUs"), href: "https://aiwisedom.com/" },
    // { name: "Privacy Policy", href: "/privacy" },
    // { name: "Terms of Service", href: "/terms" },
  ];

  const socialLinks = [
    { name: "Twitter", icon: Twitter, href: "https://twitter.com" },
    { name: "Facebook", icon: Facebook, href: "https://facebook.com" },
    { name: "LinkedIn", icon: Linkedin, href: "https://linkedin.com" },
    { name: "Instagram", icon: Instagram, href: "https://instagram.com" },
  ];

  return (
    <footer className="bg-gray-50 text-gray-600 mt-auto border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

          {/* Brand / About */}
          <div>
            <div className="flex items-center mb-3">
              <img
                src={logo}
                alt="AIWisedom Logo"
                className="h-14 w-auto object-contain"
              />
            </div>
       {/* <div className="w-11 h-12 bg-primary rounded-lg flex items-center justify-center mr-3 shadow-sm">
                <FileText className="w-7 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                HiiAi <br></br>Human Intelligence in AI
              </h3> */}
            {/* <p className="text-gray-500 text-sm leading-relaxed mb-4 max-w-sm">
              Transform your career with AI-powered resume analysis. Get instant
              feedback, ATS optimization, and personalized recommendations.
            </p> */}

            <div className="space-y-2 text-sm">
              <div className="flex items-center text-gray-500">
                <Mail className="w-4 h-4 mr-2 text-primary" />
                info@aiwisedom.com
              </div>
              {/* <div className="flex items-center text-gray-500">
                <Phone className="w-4 h-4 mr-2 text-primary" />
                +91 9876543210
              </div> */}
              {/* <div className="flex items-center text-gray-500">
                <MapPin className="w-4 h-4 mr-2 text-primary" />
                New Delhi, India
              </div> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-3 text-gray-900">
              {t("footer.quickLinks.title")}
            </h4>
            <ul className="grid grid-cols-2 gap-y-2 text-sm">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-primary transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter + Social */}
          {/* <div className="flex flex-col gap-4">
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-2 text-gray-900">
                Stay Updated
              </h4>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                />
                <button className="px-4 py-2 bg-primary text-white rounded-r-md hover:bg-blue-800 hover:text-secondary transition-colors text-sm">
                  Subscribe
                </button>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-2 text-gray-900">
                Follow Us
              </h4>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-primary transition transform hover:scale-110"
                      aria-label={social.name}
                    >
                      <IconComponent className="w-5 h-5" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-100 border-t border-gray-200 py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center justify-between text-xs text-gray-500 gap-3">
          <span>© {currentYear} Aiwisedom. {t("footer.rights")}</span>
          {/* <div className="flex space-x-5">
            <a href="/sitemap" className="hover:text-secondary">Sitemap</a>
            <a href="/accessibility" className="hover:text-secondary ">Accessibility</a>
            <a href="/cookies" className="hover:text-secondary">Cookie Policy</a>
            <a href="/gdpr" className="hover:text-secondary">GDPR</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
